// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.FrameEditor_customEmailCraftContainer__Zc8ob {
  background: #e0e0e0;
  padding: 1.7em 6px;
  height: calc(100vh - 20px);
  overflow-x: auto;
}

.FrameEditor_craftContainer__a-SiJ {
  background: #e0e0e0;
  padding: 8em 6px;
  min-height: calc(100vh - 80px);
  height: auto;
  overflow-x: auto;
}`, "",{"version":3,"sources":["webpack://./src/pages/TemplateEditor/components/FrameEditor.module.scss"],"names":[],"mappings":"AAAA;EACE,mBAAA;EACA,kBAAA;EACA,0BAAA;EACA,gBAAA;AACF;;AAEA;EACE,mBAAA;EACA,gBAAA;EACA,8BAAA;EACA,YAAA;EACA,gBAAA;AACF","sourcesContent":[".customEmailCraftContainer {\n  background: #e0e0e0;\n  padding: 1.7em 6px;\n  height: calc(100vh - 20px);\n  overflow-x: auto;\n}\n\n.craftContainer {\n  background: #e0e0e0;\n  padding: 8em 6px;\n  min-height: calc(100vh - 80px);\n  height: auto;\n  overflow-x: auto;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"customEmailCraftContainer": `FrameEditor_customEmailCraftContainer__Zc8ob`,
	"craftContainer": `FrameEditor_craftContainer__a-SiJ`
};
export default ___CSS_LOADER_EXPORT___;
